module.exports = __webpack_public_path__ + "img/tab-mine-inactive.6fe3934a.svg";